import { marginBottom, marginTop, typography } from "../../../../common/styles";
import { List } from "../../../../common/components";
import React from "react";
import { Service } from "../../../../AppDataProvider/types";
import ServiceList from "../ServiceList/ServiceList";
import CustomerTranslations from "../../../../utils/CustomerTranslations";
import sortServicesByCategory from "../sortServicesByCategory/sortServicesByCategory";
import styled from "styled-components";
export type ServicesByCategoryListProps = {
  services: Service[];
};
const CategoryName = styled.h2`
  ${typography.title};
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
  ${marginTop.zero}
  ${marginBottom.l}
`;
const ListItem = styled.li`
  &:not(:first-child) {
    ${marginTop.l}
  }
`;
export function ServicesByCategoryList(props: ServicesByCategoryListProps) {
  const {
    translateEntity
  } = CustomerTranslations.useCustomerTranslation();
  const {
    services
  } = props;
  const servicesByCategory = sortServicesByCategory(services);
  return <List data-sentry-element="List" data-sentry-component="ServicesByCategoryList" data-sentry-source-file="ServicesByCategoryList.tsx">
      {servicesByCategory.map(category => <ListItem key={category._id}>
          <CategoryName>
            {translateEntity({
          document: category,
          type: "category"
        }).name}
          </CategoryName>
          <ServiceList services={category.services} />
        </ListItem>)}
    </List>;
}
export default ServicesByCategoryList;